import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './AvatarMenu.css';

function getInitials(user) {
  const fullName = user?.signInDetails?.loginId || user?.username || 'User';
  const parts = fullName.split(/[\s@._-]+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
}

function AvatarMenu() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const imageUrl = user?.attributes?.picture || null;
  const displayName = user?.attributes?.name || user?.username || 'User';
  const initials = getInitials(user);
  const accessibleName = `${displayName} account avatar`;

  return (
    <button
      type="button"
      className="avatar-menu-button"
      onClick={() => navigate('/account')}
      aria-label={accessibleName}
      title="My account"
    >
      {imageUrl ? (
        <img src={imageUrl} alt={accessibleName} className="avatar-menu-image" />
      ) : (
        <span className="avatar-menu-initials" aria-hidden="true">
          {initials}
        </span>
      )}
    </button>
  );
}

export default AvatarMenu;
